/** Persist quotation list pagination/filters across detail navigation. */

export const QUOTATION_LIST_STATE_KEY = "quotationListState";

export type QuotationListFilters = {
  createdBy: string;
  customer: string;
  brandId: string;
  quotationSeries: string;
  fromDate: string;
  toDate: string;
};

export type QuotationListState = {
  page: number;
  maxResults: number;
  tab: string;
  appliedFilters: QuotationListFilters;
};

const defaultFilters: QuotationListFilters = {
  createdBy: "",
  customer: "",
  brandId: "",
  quotationSeries: "",
  fromDate: "",
  toDate: "",
};

export function loadQuotationListState(): Partial<QuotationListState> {
  try {
    if (typeof window === "undefined") return {};
    const raw = sessionStorage.getItem(QUOTATION_LIST_STATE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    return {
      page: Number(parsed.page) > 0 ? Number(parsed.page) : undefined,
      maxResults: Number(parsed.maxResults) > 0 ? Number(parsed.maxResults) : undefined,
      tab: typeof parsed.tab === "string" ? parsed.tab : undefined,
      appliedFilters:
        parsed.appliedFilters && typeof parsed.appliedFilters === "object"
          ? { ...defaultFilters, ...parsed.appliedFilters }
          : undefined,
    };
  } catch {
    return {};
  }
}

export function saveQuotationListState(state: QuotationListState): void {
  try {
    if (typeof window === "undefined") return;
    sessionStorage.setItem(QUOTATION_LIST_STATE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getQuotationListReturnPath(): string {
  const saved = loadQuotationListState();
  const page = saved.page && saved.page > 1 ? saved.page : 1;
  return page > 1 ? `/panel/orders?page=${page}` : "/panel/orders";
}
